import { BaseService } from "@services/BaseService";
import axios from "axios";
import { apiBaseUrl } from "@utils/baseValues";

class UserService extends BaseService {
  logout() {
    return this.post("/users/logout");
  }
  async getCurrentUser() {
    return await this.get("/users/me");
  }
  searchCompanyMembers(query: string, include_self: boolean) {
    return this.get("/users/company_members", {
      params: { query, include_self },
    });
  }
  getRoles(type: "reports" | "projects") {
    return this.get(`/users/roles/${type}`);
  }
  checkCompanyExists(companyName: string) {
    return this.get(`/users/company`, {
      params: { company_name: companyName },
    });
  }
  emailLogin(email: string) {
    return this.get("/users/email_login", {
      params: { email },
    });
  }
  loginViaToken(token: string) {
    return this.get(`/users/login/${token}`);
  }
  checkAuth = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/users/me`, {
        withCredentials: true,
      });
      return response;
    } catch (error) {
      console.error("Authentication check failed:", error);
      return null;
    }
  };
  updateNames(data: { first_name: string; last_name: string }) {
    return this.patch("/users/me/names", data);
  }
  acceptTerms() {
    return this.patch("/users/me/accept_terms", {});
  }
}

export const userService = new UserService();
